import React from 'react';
import {Accordion, AccordionActions, AccordionDetails, AccordionSummary, Button, Tooltip} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {useTheme} from "@mui/styles";
import { Alert, AlertTitle, Skeleton } from '@mui/material';

const AccordionStep = ({
	                       step,
	                       stepNumber,
	                       setStep,
	                       title,
	                       subtitle,
	                       details,
	                       actions,
	                       isBack = true,
	                       loading,
	                       error,
	                       withDetail = false
                       }) => {
	const classes = BaseStyle();
	let theme = useTheme();
	
	return (
		<React.Fragment>
			{/*onChange={() => setStep(stepNumber)} da rimettere all'accordion*/}
			<Accordion expanded={step === stepNumber}
			           onChange={() => setStep(stepNumber)}
			           className={classes.roundAccordion}
			           style={{borderRadius: 24}}>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon/>}
				>
					<Typography className={classes.heading}><b><span
						style={{fontSize: 26, color: theme.palette.primary.main}}>{stepNumber}. </span> {title}
					</b><br/>
						<span style={{color: theme.palette.text.secondary}}>{subtitle}</span>
					</Typography>
				</AccordionSummary>
				{
					loading ?
						<AccordionDetails>
							<Skeleton height={200} animation={"wave"} style={{width: "100%", borderRadius: 24}}/>
						</AccordionDetails> : error ?
							<AccordionDetails>
								<Alert severity="error" style={{borderRadius: 24}}>
									<AlertTitle>Errore</AlertTitle>
									Prova ad effettuare un refresh della pagina entro 5 minuti. Se l'errore persiste contatta gli
									sviluppatori.
								</Alert>
							</AccordionDetails>
							: withDetail ? <AccordionDetails>{details}</AccordionDetails> : details
				}
				{
					actions &&
					<AccordionActions>
						{stepNumber !== 0 && isBack && <Tooltip title={"Torna al passo precedente"}>
							<Button size={"small"} variant={"text"}
							        style={{borderRadius: 24}}
							        className={classes.roundButton} onClick={() => setStep(--stepNumber)}>
								<b>Torna indietro</b>
							</Button>
						</Tooltip>}
						<Tooltip title={"Prosegui con il passo successivo"}>
							<Button size={"small"} color={"primary"} variant={"contained"} disableElevation
							        style={{borderRadius: 24}}
							        className={classes.roundButton} onClick={() => setStep(++stepNumber)}>
								<b>Prosegui</b>
							</Button>
						</Tooltip>
					</AccordionActions>
				}
			</Accordion>
		</React.Fragment>
	);
}

export default React.memo(AccordionStep);
